// extracted by mini-css-extract-plugin
export default {"mn-drawer-content":"index_mn-drawer-content__ew0Bb","mn-drawer-header-title":"index_mn-drawer-header-title__WQ0Ij","mn-drawer-header-info":"index_mn-drawer-header-info__rswj+"};